// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1PpU7","header":"Messages_header__1z4do"};